import React from 'react'
import ReactDOM from 'react-dom'
import BigScreen from './components/BigScreen'
import eventBus from './util/eventBus'
import _ from 'lodash'

/**
 * 在setHtml中声明Root类，使用ReactDOM.render将其渲染在model.dom中
 * 在Root类的componentDidMount里，声明一个订阅，用于接收后端更新发过来的消息，从而去更新组件
 * 在update里，发布一个消息，当后端插件给自定义控件传递新数据时，就能将消息发布给Root
 * 在Root类的componentWillUnmount里，取消订阅
 * 在destoryed里，使用ReactDOM.unmountComponentAtNode卸载Root
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */
(function (KDApi) {
  function MyComponent (model) {
    this._setModel(model)
  }

  MyComponent.prototype = {
    _setModel: function (model) {
      this.model = model
    },
    init: function (props) {
      console.log('-----init', this.model.style, props)
      setHtml(this.model, props)
    },
    update: function (props) {
      console.log('-----update', this.model, props)
      eventBus.pub(this.model, 'update', props)
    },
    destoryed: function () {
      console.log('-----destoryed', this.model)
      ReactDOM.unmountComponentAtNode(this.model.dom)
    }
  }

  var setHtml = function (model, primaryProps) {
    KDApi.loadFile(['./css/index.css', './lang/zh_CN.json'], model, () => {
      class Root extends React.Component {
        constructor(props) {
          super(props)
          this.state = {
            customProps: props.customProps,
            model: props.model,
            cloudList: null,
            appList: null,
            process:0,
            liststatistics:null,
            isFirstGetProcess:true, // 用来判断是否第一次请求进度后，数据更新
            processStatu:null,
            processStatu:null,
            endProcess:false, // 结束轮询进度
            // hasListstatisticsInvoke:false, // 初始加载，是否已返回了liststatistics请求
          } 
          this.hasListstatisticsInvoke = false
          // this.num = 0
        }
        componentDidMount () {
          const { model } = this.state
          this.updateSub = eventBus.sub(model, 'update', (updateProps) => {
            const endProcess = (updateProps.data && updateProps.data.method == 'getrefreshstatisticsprocess' && updateProps.data.p === undefined) 
                                  ? true : false
            if (updateProps.data && updateProps.data.method == 'liststatistics') {
              this.hasListstatisticsInvoke = true
            }
            // if (updateProps.data && ['getrefreshstatisticsprocess', 'liststatistics'].indexOf(updateProps.data.method)) {
            //   this.num += 1
            // }  
            
            const test = updateProps
            const mergeData = Object.assign({}, this.state.customProps.data, updateProps.data)
            updateProps.data = mergeData
            // this.setState({ customProps: Object.assign({}, this.state.customProps, updateProps)})
            // this.setState({ customProps:  _.merge( this.state.customProps, updateProps)})
            this.setState({ customProps:  updateProps, endProcess: endProcess})
          })
        }
        componentWillUnmount () {
          eventBus.unsub(this.updateSub)
        }

        getLangMsg (key) {
          return KDApi.getLangMsg(model, key)
        }

        render () {
          const { customProps, model, endProcess} = this.state
          const hasListstatisticsInvoke = this.hasListstatisticsInvoke
          // const num = this.num
          // const getLangMsg = KDApi.getLangMsg
          return (
            <BigScreen model={model} 
              customProps={customProps} 
              endProcess={endProcess}
              hasListstatisticsInvoke={hasListstatisticsInvoke}
              getLangMsg={this.getLangMsg}
              // num = {num}
            />
          )
        }
      }
      ReactDOM.render(<Root model={model} customProps={primaryProps} />, model.dom)
    })
  }

  // 注册自定义组件
  KDApi.register('bigscreen', MyComponent, { isMulLang: true })
})(window.KDApi)
